import apiCall from '../../../utility/api';

type ClassificationProps = {
  overlayOpenNew?: any;
  devicesData?: any;
  devicesOfTenant?: boolean;
  selectedRowIdInSubTable?: any;
  setSelectedRowIdInSubTable?: any;
  setSelectedRowIdInTable?: any;
  tenant?: any;
  exportBtnClicked?: any;
  data?: any;
  func?: any;
  searchVal?: any;
  pageNo?: any;
  setTotalPages?: any;
  setTotalRecords?: any;
  isfilter?: any;
  dropDownValue1?: any;
  setIsFilter?: any;
  dropDownValue2?: any;
  filterArray?: any;
  setLinkedDeviceCnt?: any;
  setRefreshToast?: any;
  setRefresh?: any;
  isRefresh?: any;
  classificationName?: string | any;
  addClassification?: boolean;
  deviceSearchVal?: any;
  configGroupBtnCliked?: any;
  csvDevicesList?: any;
  deleteClassification?: boolean;
  setDevicesOfTenant?: any;
  setDeleteClassification?: any;
  setDeleteEnabled?: any;
  setClassificationNameValidation?: any;
  setOverlayOpenNew?: any;
  setAddClassification?: any;
  selectedValue?: number;
  setGroupConfigCnt?: any;
  setIsToast?: any;
  setToastMessage?: any;
  setErrorToast?: any;
  setConfigGroupBtnCliked?: any;
  operationType?: any;
  setDevicesData(data: any): any;
  setExportDetails?: any;
  setExportBtnClicked?: any;
  selectedRowIdInTable: any[];
  linkedDeviceCnt?: any;
  setValidationText?: any;
  isOverlayFilter?: any;
  overlayFilterArray?: any;

}

export const Groups_func = (props: ClassificationProps) => {
  const getGroupsList = async (whereCondition: object, limit: number | null, offset: number | null) => {
    try {
      const { status, data } = await apiCall('/groups/getClassification', { ...whereCondition, limit, offset });

      if (status === 'success' && data?.length > 0) {
        data.map(async (val: any) => {
          if (!props.linkedDeviceCnt.hasOwnProperty(val.classificationName)) {
            var linkedDeviceCnt = await getGroupedDevicesList({ tenant: props.tenant, classification: val.classificationName }, null, 0);

            props.setLinkedDeviceCnt((prev: any) => ({
              ...prev,
              [`${val.classificationName}`]: linkedDeviceCnt,
            }));
          }
        });

        props.func(data);
      } else {
        props.func([]);
      }
    } catch (error) {
      console.log("getGroupsList error=", error);
      props.func([]);
    }
  };

  const getGroupsListCnt = async (whereCondition: any) => {
    try {
      const { status, data } = await apiCall('/groups/getClassificationCount', whereCondition);

      if (status === 'success') {
        props.setTotalRecords(data.totalRecords);
        props.setTotalPages(data.totalPages);
      } else {
        props.setTotalRecords(0);
        props.setTotalPages(1);
      }
    } catch (error) {
      console.log("getGroupsListCnt error=", error);
      props.setTotalRecords(0);
      props.setTotalPages(1);
    }
  };

  const getExportData = async (condition: object) => {
    try {
      const { status, data } = await apiCall(`/groups/getClassification`, condition);

      if (status === 'success') {
        props.setExportDetails && props.setExportDetails(data);
      }
    } catch (error) {
      console.log("getExportData error=", error);
    }

    props.setExportBtnClicked(false);
  }

  const getDevicesList = async (whereCondition: any) => {
    try {
      const { status, data } = await apiCall(`/census/getCensus`, { ...whereCondition, limit: 20, offset: 0 });

      if (status === 'success' && data?.length > 0) {
        var tempArr: any = [];
        // data.map((val: any) => {
        //   tempArr.push(val.host);
        // })
        props.setDevicesData(data);
      } else {
        props.setDevicesData([]);
      }
    } catch (error) {
      console.log("getDevicesList error=", error);
      props.setDevicesData([]);
    }
  };

  const getGroupedDevicesList = async (whereCondition: any, limit: number | null, offset: number) => {
    try {
      const { status, data } = await apiCall(`/groups/getDeviceCount`, whereCondition);

      if (status === 'success' && data.length > 0) {
        return data.length;
      } else {
        return 0;
      }
    } catch (error) {
      console.log("getGroupedDevicesList error=", error);
      return 0;
    }
  };

  const validateClassificationName = async (whereCondition: object) => {
    if (!whereCondition || Object.keys(whereCondition).length === 0) {
      props.setClassificationNameValidation(false);
      props.setValidationText('');
      return;
    };    
    try {
      const { status, msg } = await apiCall('/groups/getList', whereCondition);

      if (status === 'success') {
        msg === "name available" ? props.setClassificationNameValidation(true) : props.setClassificationNameValidation(false);
        props.setValidationText(msg);
      } else {
        props.setClassificationNameValidation(false);
        props.setValidationText('');
      }
    } catch (error) {
      console.log("validateClassificationName error=", error);
      props.setClassificationNameValidation(false);
      props.setValidationText('');
    }
  }

  const configureClassfication = async (tenant: string, ids: any[]) => {
    try {
      const { status, data } = await apiCall(`/groups/configureClassfication`, { tenant: tenant, id: ids });

      if (status === 'success') {
        props.setGroupConfigCnt(props.selectedRowIdInTable?.length);

        props.setConfigGroupBtnCliked(false);
        props.setOverlayOpenNew(false);
      } else {
        const failedConfigGrps = data.failed_groups;
        props.setGroupConfigCnt(failedConfigGrps.length);
        let summary = '';

        if (ids.length === failedConfigGrps.length) {
          summary = `Configuration failed for all the classifications`;
        } else {
          summary = `Configuration creation failed for ${failedConfigGrps?.length} classification`;
        }

        props.setConfigGroupBtnCliked(false);
        props.setOverlayOpenNew(false);
        props.setErrorToast(true);
        props.setToastMessage(summary);
        // props.setToastMessage(`Configuration failed`);
      }
    } catch (error) {
      console.log("configureClassfication error=", error);

      props.setErrorToast(true);
      props.setToastMessage(`Configuration failed`);
      props.setConfigGroupBtnCliked(false);
      props.setOverlayOpenNew(false);
    }
  }

  const viewGroupDetails = async (mgroupid: number) => {
    // const { data, loading, error } = await client.query({
    //   query: viewGroupDetailsQuery,
    //   variables: { mgroupid }
    // });

    // if (!loading && data) {
    //   console.log("viewGroupDetails=", data);
    // }
  }

  const addClassification = async (name: string) => {
    var classificationName = name.trim();
    const type = props.selectedValue == 1 ? 'manual' : props.selectedValue == 2 ? 'csv' : '0';

    try {
      const { status } = await apiCall(`/groups/addClassification`, { tenant: props.tenant, type: type, classification: classificationName, devices: props.selectedRowIdInSubTable });

      if (status === 'success') {
        props.setIsToast(true);

        setTimeout(() => {
          getGroupsList({ tenant: props.tenant }, 50, props.pageNo);
          getGroupsListCnt({ tenant: props.tenant });
        }, 3000);
      } else {
        props.setErrorToast(true);
        props.setToastMessage(`${classificationName} classification creation failed`);
      }
    } catch (error) {
      console.log("addClassification error=", error);

      props.setErrorToast(true);
      props.setToastMessage(`${classificationName} classification creation failed`);
    }

    setTimeout(() => {
      props.setAddClassification(false);
      props.setSelectedRowIdInSubTable([]);
      props.setSelectedRowIdInTable([]);
    }, 3000);

    props.setOverlayOpenNew(false);
  };

  const deleteUnGroupedClassification = async (ids: any[]) => {
    try {
      const { status } = await apiCall('/groups/deleteClassification', { id: ids, tenant: props.tenant });

      if (status === 'success') {
        props.setDeleteEnabled(false);
        props.setDeleteClassification(false);
        props.setIsToast(true);
      } else {
        props.setDeleteEnabled(false);
        props.setDeleteClassification(false);

        props.setErrorToast(true);
        props.setToastMessage(`${props.selectedRowIdInTable?.length} ${props.selectedRowIdInTable?.length > 1 ? 'Classifications' : 'Classification'} deletion failed`);
      }

      props.setSelectedRowIdInTable([]);
    } catch (error) {
      console.log("deleteUnGroupedClassification error=", error);

      props.setDeleteEnabled(false);
      props.setDeleteClassification(false);
      props.setSelectedRowIdInTable([]);
      props.setErrorToast(true);
      props.setToastMessage(`${props.selectedRowIdInTable?.length} ${props?.selectedRowIdInTable?.length > 1 ? 'Classifications' : 'Classification'} deletion failed`);
    }
  }

  const getCensusList = async (whereCondition: object, limit: number | null = null, offset: number | null = null) => {
    try {
      const { status, data } = await apiCall('/census/getCensus', { ...whereCondition, limit, offset });

      if (status === 'success' && data?.length > 0) {
        props.setDevicesOfTenant(data);
      }
    } catch (error) {
      console.log("getCensusList error=", error);
    }
  };

  // // props.deleteClassification && contextValue.selectedRowIdInTable.length > 0 &&
  // //   deleteUnGroupedClassification(contextValue.selectedRowIdInTable);
  console.log("props.classificationName=", props.classificationName);
  console.log("props.overlayOpenNew=", props.overlayOpenNew);

  if (props.deleteClassification && props.selectedRowIdInTable?.length > 0) {
    deleteUnGroupedClassification(props.selectedRowIdInTable);
  } else if (props.isfilter === true) {
    const whereCondition = { "tenant": props.tenant, function: 'filter', filter: props.filterArray };
    getGroupsList(whereCondition, 50, props.pageNo);
    getGroupsListCnt(whereCondition);
  } else if (props?.csvDevicesList?.length > 0 && props.devicesOfTenant === null) {
    getCensusList({ tenant: props.tenant }, null, null);
  } else if (props.searchVal?.length > 0 && props.searchVal != '' && !(props?.configGroupBtnCliked) && !props.overlayOpenNew) {
    console.log("group search function1");
    getGroupsList({ function: 'search', tenant: props.tenant, search: props.searchVal }, 50, props.pageNo);
    getGroupsListCnt({ function: 'search', tenant: props.tenant, search: props.searchVal });

  } else if (props?.deviceSearchVal?.length > 0 && props?.deviceSearchVal != '' && !(props?.configGroupBtnCliked && props.overlayOpenNew)) {
    console.log("group search function2")
    getDevicesList({ tenant: props.tenant, type: 'search', search: props.deviceSearchVal, test: '2' })
    //this is overlay filter
  } else if (props?.isOverlayFilter === true && !(props?.configGroupBtnCliked && props.overlayOpenNew)) {
    console.log("group overlay filter function")
    console.log("Overlay Filter Array:", props.overlayFilterArray);
    getDevicesList({ filter: props.overlayFilterArray, tenant: props.tenant, type: 'filter', test: '1' });

  } else if (props?.addClassification) {
    addClassification(props.classificationName);
  } else if (props?.configGroupBtnCliked) {
    configureClassfication(props.tenant, props.selectedRowIdInTable);
  } else if (props.isRefresh) {
    // props.setRefresh(false);
    getGroupsList({ tenant: props.tenant }, 50, props.pageNo);
    getGroupsListCnt({ tenant: props.tenant });
    // props.setRefreshToast(true);
    // setTimeout(() => {
    //   props.setRefreshToast(false);
    // }, 3000);
  } else if (props.exportBtnClicked) {
    getExportData({ function: 'export', tenant: props.tenant });
  } else if (props?.classificationName?.length > 0 && props.overlayOpenNew && props.selectedValue === 0) {
    validateClassificationName({ "tenant": props.tenant, function: 'validate', classification: props.classificationName });
  } else {
    !props.overlayOpenNew && getGroupsList({ tenant: props.tenant }, 50, props.pageNo);
    !props.overlayOpenNew && getGroupsListCnt({ tenant: props.tenant });

    (!props.overlayOpenNew || props.classificationName?.length > 0) && getDevicesList({ tenant: props.tenant, test: '3' });
  }

  // //viewGroupDetails(349); //it should be called when clicked on view group details
}
